var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.526 5.116L13.347 0.658997L1.658 9.997L1.01 9.99V10H0.5V22H21.5V10H20.538L18.624 4.401L16.526 5.116ZM18.425 10H8.397L15.866 7.454L17.388 6.967L18.425 10ZM14.55 5.79L6.84 8.418L12.946 3.54L14.55 5.79ZM2.5 18.169V13.829C2.92218 13.68 3.30565 13.4384 3.62231 13.1219C3.93896 12.8054 4.18077 12.4221 4.33 12H17.67C17.8191 12.4223 18.0609 12.8058 18.3775 13.1225C18.6942 13.4391 19.0777 13.6809 19.5 13.83V18.17C19.0777 18.3191 18.6942 18.5609 18.3775 18.8775C18.0609 19.1942 17.8191 19.5777 17.67 20H4.332C4.18218 19.5777 3.93996 19.1941 3.62302 18.8774C3.30607 18.5606 2.9224 18.3186 2.5 18.169Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetIcon);
export default __webpack_public_path__ + "static/media/monet-icon.f5cbc07b5572e188464aa17bd2c93495.svg";
export { ForwardRef as ReactComponent };